'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconClockExclamation, iconClockExclamationTag } from '@ni/nimble-components/dist/esm/icons/clock-exclamation';
import { wrap } from '../../utilities/react-wrapper';

export type { IconClockExclamation };
export { iconClockExclamationTag };
export const NimbleIconClockExclamation = wrap(IconClockExclamation);